import CommonModal from 'components/common/CommonModal';
import ScreenLayout from 'components/common/ScreenLayout';
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {colors} from 'styles/colors';
import {minmax} from 'utils/minmax';
import DefaultText from 'components/common/DefaultText';
import Pagination from 'components/common/Pagination';
import {useNavigate} from 'react-router-dom';
import {useRecoilValue} from 'recoil';
import {userInfoState} from 'utils/Atoms';
import {
  searchBackOfficePartnerCompany,
} from 'function/api';
import {convertTotalPage} from 'function/converter';
import ContainerHeader from 'components/common/ContainerHeader';
import {formatPhoneNumber} from 'utils/fomatPhoneNumber';
import {formatBusinessRegisterNumber} from 'function/formatter';
import DefaultInput from 'components/common/DefaultInput';
import DefaultImageView from 'components/common/DefaultImageView';
import ChangePartnerCompanyNameModal from 'components/partnerCompany/ChangePartnerCompanyNameModal';
import ChangeBusinessRegisterNumberModal from 'components/common/ChangeBusinessRegisterNumberModal';

const PartnerCompany = () => {
  // locale
  const [isLoading, setIsLoading] = useState(false);
  const [errorModal, setErrorModal] = useState({});

  const navigate = useNavigate();
  const userInfo = useRecoilValue(userInfoState);

  const [requestTongCurrentPage, setRequestTongCurrentPage] = useState(1);
  const [requestTongTotalPage, setRequestTongTotalPage] = useState(1);
  const [requestTongData, setRequestTongData] = useState<null | any>(null);
  const [selectItem, setSelectItem] = useState<null | any>(null);
  const [keyword, setKeyword] = useState('');

  const [modal, setModal] = useState('');

  const modalData: {[key: string]: any} = {
    // 본사시스템 서비스 준비중
    servicePreparing: {
      title: 'servicePreparing',
      firstButtonText: 'confirm',
      firstButtonClick: () => {
        setModal('');
      },
    },
  };

  useEffect(() => {
    if (!userInfo?.accessToken) {
      navigate('/');
    }
  }, []);

  useEffect(() => {
    if (userInfo?.accessToken) {
      getPartnerCompanyList();
    }
  }, [userInfo, requestTongCurrentPage]);

  const getPartnerCompanyList = () => {
    searchBackOfficePartnerCompany({
      userInfo,
      setErrorModal,
      setIsLoading,
      page: requestTongCurrentPage,
      keyword,
    }).then(result => {
      if (result) {
        setRequestTongData(result);

        const resTotalPage = convertTotalPage(result.totalCount ?? 0, 10);
        setRequestTongTotalPage(resTotalPage);
      }
    });
  };

  return (
    <ScreenLayout isLoading={isLoading} errorModal={errorModal}>
      <Container>
        <ContainerHeader
          mainTitle="fieldManagement"
          subTitle="partnerCompany"
        />

        <Inner>
          <DefaultText
            text="협력사 리스트"
            textStyle={{
              fontSize: minmax(25),
              fontWeight: 'bold',
              borderBottom: `3px solid ${colors.primary}`,
              width: 'fit-content',
              marginBottom: minmax(20),
            }}
          />

          <SearchArea>
            <InputWrap>
              <DefaultInput
                value={keyword}
                setValue={(e: any) => setKeyword(e)}
                placeholderText="searchPlaceholder"
                wrapperStyle={{height: '100%'}}
                onKeyPress={(e: any) => {
                  if (e.key === 'Enter') {
                    getPartnerCompanyList();
                  }
                }}
              />
              <DefaultImageView
                source="images/common/search.png"
                style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  height: '100%',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  getPartnerCompanyList();
                }}
              />
            </InputWrap>
          </SearchArea>

          <ResultArea>
            <ResultHeader>
              <DefaultText
                text=""
                textStyle={{
                  ...ResultHeaderTextStyle,
                  flex: 0.4,
                }}
              />

              <DefaultText
                text="partnerName"
                textStyle={ResultHeaderTextStyle}
              />
              <DefaultText
                text="phone"
                textStyle={{...ResultHeaderTextStyle, flex: 1.5}}
              />
              <DefaultText
                text="businessRegistrationNumber"
                textStyle={ResultHeaderTextStyle}
              />

              <DefaultText
                text="constructionCompanyName"
                textStyle={ResultHeaderTextStyle}
              />
            </ResultHeader>

            <ResultList>
              {requestTongData?.totalCount ? (
                requestTongData.partnerCompanies.map(
                  (item: any, index: number) => (
                    <ResultItem
                      key={item.uuid}
                      onClick={() => {
                        // navigate('/partnerCompanyDetail', {
                        //   state: {
                        //     uuid: item.uuid,
                        //   },
                        // });
                      }}>
                      <DefaultText
                        text={(
                          (requestTongCurrentPage - 1) * 10 +
                          index +
                          1
                        ).toString()}
                        textStyle={{
                          ...ResultHeaderTextStyle,
                          flex: 0.4,
                        }}
                      />

                      <DefaultText
                        text={item.name || '-'}
                        textStyle={{...ResultItemStyle, cursor: 'pointer', textDecoration: 'underline'}}
                        onClick={() => setSelectItem({...item, type: 'changeName'})}
                      />
                      <DefaultText
                        text={
                          item.phone
                            ? formatPhoneNumber({
                                phone: item.phone,
                                locale: item.locale,
                              })
                            : '-'
                        }
                        textStyle={{...ResultItemStyle, flex: 1.5}}
                      />
                      <DefaultText
                        text={formatBusinessRegisterNumber(
                          item.businessRegisterNumber,
                        )}
                        textStyle={{...ResultItemStyle, cursor: 'pointer', textDecoration: 'underline'}}
                        onClick={() => setSelectItem({...item, type: 'changeBizReg'})}
                      />
                      <DefaultText
                        text={item.contractor.name}
                        textStyle={ResultItemStyle}
                      />
                      {/* <DefaultText
                        text={item.createParams.placeClassification}
                        textStyle={{...ResultItemStyle, flex: 0.8}}
                      />
                      <DefaultText
                        text={item.createParams.name}
                        textStyle={{...ResultItemStyle, flex: 2}}
                      />
                      <DefaultText
                        text={
                          item.createParams.address +
                          (item.createParams.addressDetail
                            ? ', ' + item.createParams.addressDetail
                            : '')
                        }
                        textStyle={{...ResultItemStyle, flex: 2}}
                      /> */}
                    </ResultItem>
                  ),
                )
              ) : (
                <DefaultText
                  text="noDataMsgTongList"
                  textStyle={{
                    color: colors.darkGray,
                    textAlign: 'center',
                    margin: `${minmax(12)} 0`,
                  }}
                />
              )}
            </ResultList>
          </ResultArea>

          {requestTongData?.totalCount ? (
            <Pagination
              totalPage={requestTongTotalPage}
              currentPage={requestTongCurrentPage}
              setCurrentPage={setRequestTongCurrentPage}
            />
          ) : null}
        </Inner>
      </Container>

      {modal !== '' && (
        <CommonModal
          title={modalData[modal].title}
          detail={modalData[modal].detail}
          firstButtonText={modalData[modal].firstButtonText}
          firstButtonStyle={modalData[modal].firstButtonStyle}
          secondButtonText={modalData[modal].secondButtonText}
          secondButtonStyle={modalData[modal].secondButtonStyle}
          firstButtonClick={modalData[modal].firstButtonClick}
          secondButtonClick={modalData[modal].secondButtonClick}
          closeModal={modalData[modal].firstButtonClick}
        />
      )}

      {selectItem?.type === 'changeName' && (
        <ChangePartnerCompanyNameModal
          selectItem={selectItem}
          closeModal={() => setSelectItem(null)}
          setIsLoading={setIsLoading}
          setErrorModal={setErrorModal}
        />
      )}
      {selectItem?.type === 'changeBizReg' && (
        <ChangeBusinessRegisterNumberModal
          selectItem={selectItem}
          entityType="partner-companies"
          closeModal={() => setSelectItem(null)}
          setIsLoading={setIsLoading}
          setErrorModal={setErrorModal}
        />
      )}
    </ScreenLayout>
  );
};

export default PartnerCompany;

const Container = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  flex-direction: column;
  margin-bottom: ${minmax(50)};
`;

const Inner = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: ${minmax(20)};
`;

const ResultArea = styled.div`
  margin-bottom: ${minmax(40)};
  border-bottom: 1px solid ${colors.darkGray};
`;

const ResultHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: ${minmax(52)};
  background-color: #f7f7f7;
`;

const ResultList = styled.ul`
  /* height: 728px; */
  /* overflow-y: auto; */

  // 스크롤바 삭제
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
`;

const ResultItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${minmax(8)} 0;
  min-height: ${minmax(52)};
  border-top: 1px solid ${colors.lightGrey};
  &:last-child {
    border-bottom: none;
  }
`;

const ResultHeaderTextStyle: React.CSSProperties = {
  flex: 1,
  textAlign: 'center',
  color: '#585858',
};

const ResultItemStyle: React.CSSProperties = {
  flex: 1,
  textAlign: 'center',
  // overflow: 'hidden',
  // textOverflow: 'ellipsis',
  // whiteSpace: 'nowrap',
  // wordBreak: 'break-all',
};

const SearchArea = styled.div`
  width: 100%;
  height: ${minmax(60)};
  margin-top: ${minmax(20)};
  display: flex;
  flex-direction: row;
  column-gap: 2%;
  margin-bottom: ${minmax(20)};
`;

const InputWrap = styled.div`
  width: 100%;
  position: relative;
`;
